<template>

  <div class="component q-px-md q-py-xs flex">
    <q-btn
        flat
        dense
        :icon="ICONS.homeOutline"
        label="Меню"
        stack
        class="c-btn-normal"
        @click="onNavHome"
    />

    <q-btn
        flat
        dense
        :icon="ICONS.searchAlt"
        label="Поиск"
        stack
        class="c-btn-normal"
        to="/catalog/search"
    />

    <div class="q-px-sm">
      <q-btn
          :icon="ICONS.basket"
          size="12px"
          round
          color="primary"
          class=""
          @click="onNavBasket"
          v-if="basketIsEmpty"
      />
      <div class="c-btn-cart" v-else>
        <q-btn
            :icon="ICONS.basket"
            round
            color="primary"
            stack
            size="20px"
            dense
            @click="onNavBasket"
        >
          <span class="c-btn-cart__price">
               <AnimatedNumber
                   :number="pricePay"
                   append=" ₽"
               />
          </span>
        </q-btn>
      </div>
    </div>

    <q-btn
        flat
        dense
        :icon="ICONS.person"
        label="Профиль"
        stack
        class="c-btn-normal"
        @click="onNavPersonal"
        :loading="!scopeUserFetched"
    >
      <q-badge color="primary-light" floating v-if="ordersStore.ordersActive.length">
        {{ ordersStore.ordersActive.length }}
      </q-badge>
    </q-btn>

    <q-btn
        flat
        dense
        :icon="ICONS.moreHoriz"
        label="Еще"
        stack
        class="c-btn-normal"
        @click="drawerMainModel = !drawerMainModel"
    />

  </div>

</template>

<script setup lang="ts">

import {ICONS} from "@/assets/icons";
import {storeToRefs} from "pinia";
import {useVorderTotalStore} from "@/modules/shop/store/vorder-total";
import {useBasketStore} from "@/modules/shop/store/basket";
import {useLayoutStore} from "@/stores/layout";
import {useUserStore} from "@/modules/user/store/user";
import {useRouter} from "vue-router";
import {useScopeQuery} from "@/core/store/scopeQuery";
import {useOrdersStore} from "@/modules/shop/store/orders";

const ordersStore = useOrdersStore()
const scopeQueryStore = useScopeQuery()
const layoutStore = useLayoutStore()
const basket = useBasketStore()
const user = useUserStore()

const {isAuthorized} = storeToRefs(user)
const {drawerMainModel} = storeToRefs(layoutStore)
const {scopeUserFetched} = storeToRefs(scopeQueryStore)

const vorderTotal = useVorderTotalStore()

const {pricePay} = storeToRefs(vorderTotal)
const {basketIsEmpty} = storeToRefs(basket)

const router = useRouter()

const onNavHome = () => {
  router.push("/")
  scrollTo(0, 0)
}

const onNavPersonal = () => {
  if (isAuthorized.value) {
    router.push("/personal/profile")
  } else {
    router.push("/auth?redirect=profile")
  }
}

const onNavBasket = () => {
  router.push("/order")
}

</script>

<style lang="scss" scoped>

.component {
  justify-content: space-between;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 50;
  border-top: 1px solid #eee;
  box-shadow: 0 4px 8px 6px rgba(34, 60, 80, 0.2);
}

.c-btn-cart {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);

  .q-btn {
    position: relative;
    margin: auto;

    :deep() {

      .q-icon {
        margin-top: -5px;
        font-size: 13px;
      }

      .block {
        line-height: 1;
        position: absolute;
        white-space: nowrap;
        font-size: 12px;
        font-weight: bold;
        bottom: 13px;
      }
    }
  }
}

.c-btn-cart__price {
  font-size: 12px;
  line-height: 1;
  margin-top: 4px;
  display: block;
}

.c-btn-normal {
  font-size: 11px;

  :deep() {
    .q-icon {
      font-size: 30px;
    }

    .block {
      margin-top: -3px;
      display: none !important;
    }
  }
}

</style>
